import React from 'react'
import { Link } from 'react-router-dom'
import SearchForm from './SearchForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars,faUser,faBell,faTh } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/MC-Logo2.png'



const Navbar = () => {

  const [menu, setMenu] = React.useState(false);
  let newMenu;

  const menuClick = () => {
    newMenu = !menu
    setMenu(newMenu);
    console.log(newMenu);
  };

  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="menu-logo" >
          <div className="nav-logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
        </div>
        <SearchForm />
        <div className="right-icons">
          <div className="icons" id="CardsDisplay">
            <FontAwesomeIcon icon={faTh} />
          </div>
          <div className="icons" id="Notifications">
            <FontAwesomeIcon icon={faBell} />
          </div>
          <div className="icons" id="User">
            <FontAwesomeIcon icon={faUser} />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar
